const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  closeOnOutClick,
  onConfirm,
  confirmButton = "Confirm",
  dismissible = true,
  showConfirm = true,
  showCancel = true,
  customClass,
}) => {
  if (!isOpen) return null;

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-[200] bg-black/50`} onClick={closeOnOutClick ? onClose : undefined}>
      <div
        className={`bg-white rounded-xl py-10 px-8 w-[90%]  text-center relative ${
          customClass ? customClass : "max-w-xl"
        }`}
      >
        {/* Close button */}
        {dismissible && (
          <button
            title="Click to close modal"
            className="absolute top-2 right-4 text-secondary hover:text-orange/60 text-3xl font-bold"
            onClick={onClose}
          >
            &times;
          </button>
        )}

        {/* Title */}
        {title && <h2 className="text-2xl  mb-4">{title}</h2>}

        {/* Content */}
        <div className={onConfirm ? "mb-6" : "mb-0"}>{children}</div>

        {/* Confirm / Cancel Buttons */}
        {onConfirm && (
          <div className="flex justify-center gap-4">
            {showCancel && (
              <button
                title="Click to cancel"
                className="px-6 py-2 bg-gray text-gray-700 rounded-lg hover:bg-gray-400"
                onClick={onClose}
              >
                Cancel
              </button>
            )}
            {showConfirm && (
              <button
                className="px-6 py-2 bg-orange text-white rounded-lg hover:bg-green-700"
                onClick={onConfirm}
              >
                {confirmButton}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Modal;
